import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { authTokenSelector } from '../../../selectors/auth';
import { actionCheckCEX } from '../../../actions/cex_trading';
import { CexAPI } from '../../../store/createStore';
import { actionCreateNotification } from '../../../actions/notifications';

import './styles.scss';
import { EXCHANGE_MAPPING } from '../../ConnectedWallet/SideBarWallet/CEXWallet/ExchangeSelector/helpers';

interface ICexConnectModalProps {
  exchange: string;
  onCancel: () => void;
}

const CexConnectModal = ({ exchange, onCancel }: ICexConnectModalProps) => {
  const [api, setApi] = useState('');
  const [secret, setSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const authToken = useSelector(authTokenSelector);
  const dispatch = useDispatch();

  const onConnect = () => {
    if (!loading) {
      setLoading(true);
      CexAPI.activateAPIKey(exchange, api, secret, authToken!)
        .then((res) => {
          if (res.success) {
            dispatch(
              actionCreateNotification({
                kind: 'info',
                message: `Successfully connected to the ${EXCHANGE_MAPPING[exchange].label}`,
              })
            );
            dispatch(actionCheckCEX());
          } else {
            dispatch(
              actionCreateNotification({
                kind: 'error',
                message: `Could not connect to ${EXCHANGE_MAPPING[exchange].label}, please check key, secret, permissions`,
              })
            );
          }
          setLoading(false);
          onCancel();
        })
        .catch(() => {
          dispatch(
            actionCreateNotification({
              kind: 'error',
              message: `Could not connect to ${EXCHANGE_MAPPING[exchange].label}, please check key, secret, permissions`,
            })
          );
          setLoading(false);
          onCancel();
        });
    }
  };

  return (
    <div className='cex_connect_modal'>
      <div className='cex_connect_modal__header'>
        <Text size={14} className='text--weight-600 text--white'>
          Connect {EXCHANGE_MAPPING[exchange].label}
        </Text>
      </div>
      <div className='cex_connect_modal__close icon-close' onClick={onCancel} />
      <Text
        size={12}
        className='text--grey-200 text--weight-500'
        style={{ style: { lineHeight: '20px' } }}
      >
        API keys are required to establish a secure and authenticated connection
        with your exchange account. They enable Kattana to retrieve your account
        information, execute trades on your behalf, and access real-time market
        data to provide you with accurate trading insights and analysis.
      </Text>
      <div className='seo_page__sidebar__converter__field cex_connect_modal__field'>
        <div className='cex_connect_modal__field__pre'>
          <Text size={14} className='text--grey-200 text--weight-500'>
            API
          </Text>
        </div>
        <input
          readOnly={loading}
          className='field text--grey-400'
          value={api}
          onChange={(e) => setApi(e.target.value)}
        />
      </div>
      <div className='seo_page__sidebar__converter__field cex_connect_modal__field'>
        <div className='cex_connect_modal__field__pre'>
          <Text size={14} className='text--grey-200 text--weight-500'>
            Secret
          </Text>
        </div>
        <input
          readOnly={loading}
          type='password'
          className='field text--grey-400'
          value={secret}
          onChange={(e) => setSecret(e.target.value)}
        />
      </div>
      <div className='cex_connect_modal__btn'>
        <Button
          text='Connect'
          action={onConnect}
          size='l'
          variant='primary'
          loading={loading}
        />
      </div>
    </div>
  );
};

export default CexConnectModal;
